<template>
    <div>
        <az-back-button :route="{name: 'usuarioBusca'}" text="Voltar para listagem"></az-back-button>
        <az-container>
            <usuario-acoes :inserindo=true />
            <form>
                <usuario-dados v-model="usuario" inserindo />
                <div class="az-actions-form" style="margin-top: 20px">
                    <div class="align-left"></div>
                    <div class="align-right">
                        <button class="action-secundary" @click.prevent="cancelar">Cancelar</button>
                        <button class="action-primary" @click.prevent="inserir">Salvar</button>
                    </div>
                </div>
            </form>
        </az-container>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import UsuarioAcoes from './acoes/UsuarioAcoes'
    import UsuarioDados from './UsuarioDados'

    export default {
        name: 'UsuarioNovo',
        $_veeValidate: {
            validator: 'new'
        },
        components: {UsuarioAcoes, UsuarioDados},
        data() {
            return {
                configuracoesNovoUsuario: {},
                usuario: {}
            }
        },
        computed: {
            ...mapState(['loki'])
        },
        async mounted() {
            this.configuracoesNovoUsuario = await this.buscarConfiguracoesNovoUsuario()
        },
        methods: {
            ...mapActions([
                actionTypes.ATRIBUIR_DOMINIO_PERFIL_NOVO_USUARIO,
                actionTypes.BUSCAR_CONFIGURACOES_NOVO_USUARIO,
                actionTypes.ENVIAR_EMAIL_INFO_LOGIN,
                actionTypes.INSERIR_USUARIO
            ]),
            async atribuirPermissoesUsuario() {
                this.setMensagemLoading('Atribuindo permissões...')
                await this.atribuirDominioPerfilNovoUsuario(this.montarPayloadDominioPerfil())
            },
            cancelar() {
                this.$router.push({name: 'usuarioBusca'})
            },
            complementarInformacoesUsuario() {
                this.usuario.telefone = this.removerMascaraTelefone(this.usuario.telefone)
                this.usuario.emailContato = this.usuario.email
                this.usuario.situacao = 'ATIVO'
                this.usuario.tipoUsuario = 'INTERNO'
                this.usuario.idioma = 'pt-BR'
                this.usuario.pais = this.configuracoesNovoUsuario.paisDefaultId
            },
            async enviarInformacoesAcessoPorEmail() {
                this.setMensagemLoading('Enviando informações de acesso por e-mail...')
                await this.enviarEmailInfoLogin(this.usuario.id)
            },
            exibirEmModoVisualizacao() {
                this.$router.push({name: 'usuarioDetalhe', params: {id: this.usuario.id}})
            },
            async inserir() {
                const validado = await this.$validator._base.validateAll()
                if (!validado) {
                    return
                }
                this.complementarInformacoesUsuario()
                await this.salvarNovoUsuario()
                await this.atribuirPermissoesUsuario()
                await this.enviarInformacoesAcessoPorEmail()
                this.mostrarNotificacaoSucessoDefault()
                this.exibirEmModoVisualizacao()
            },
            montarPayloadDominioPerfil() {
                const perfis = [this.configuracoesNovoUsuario.perfilOrgaoPublicoId]
                const unidadesOrganizacionais = [this.loki.user.domainId]
                return {
                    idUsuario: this.usuario.id,
                    idProduto: this.loki.product.id,
                    perfis,
                    unidadesOrganizacionais
                }
            },
            async salvarNovoUsuario() {
                this.setMensagemLoading('Aguarde enquanto inserimos o usuário...')
                this.usuario = await this.inserirUsuario(this.usuario)
            }
        }
    }
</script>